function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.9 9.1c-.3-.9-1.1-1.5-2-1.5h-6L14 1.9C13.7 1 12.9.5 12 .5c-.9 0-1.7.6-2 1.5L8.2 7.7h-6c-.9 0-1.7.6-2 1.5s0 1.8.8 2.4L5.8 15l-1.9 5.7c-.3.9 0 1.8.8 2.4.4.3.8.4 1.2.4s.9-.1 1.2-.4l4.9-3.5 4.8 3.5c.8.5 1.7.6 2.5 0s1.1-1.5.8-2.4L18.3 15l4.8-3.5c.8-.6 1.1-1.5.8-2.4zm-1.6 1.2l-5.7 4.1 2.1 6.7c.1.5-.2.7-.3.8s-.4.3-.8 0L12 17.8 6.3 22c-.4.3-.7.1-.8 0-.1-.1-.4-.3-.3-.8l2.2-6.7-5.7-4.1c-.4-.3-.3-.7-.3-.8s.2-.5.7-.5h7.1l2.1-6.7c.1-.5.5-.5.7-.5.1 0 .5 0 .7.5l2.2 6.7h7c.5 0 .6.4.7.5 0 .1.1.5-.3.7z"
});

function SvgActivityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgActivityIcon;